/**
 * Takes a translation object and resolves matching references within itself
 * i.e. "COMPONENT.YES": "@:GENERIC.YES" = "COMPONENT.YES": "Yes"
 *
 * @param translations Object e.g. en.json
 * @param referenceLookup matching references
 * @example
 *   const translation = this.loadTranslation('/assets/i18n/en.json').pipe(map((translation) => rdlMapReferencedTranslation(translation)));
 */
function rdlMapReferencedTranslation(translations, referenceLookup) {
  try {
    referenceLookup = referenceLookup || rdlCreateTranslationReferenceLookup(translations, {});
    const keys = Object.keys(translations);
    return keys.reduce((acc, key) => {
      if (typeof translations[key] === 'object') {
        acc[key] = rdlMapReferencedTranslation(translations[key], referenceLookup);
      } else {
        const translation = translations[key];
        if (translation && translation.startsWith('@:')) {
          const referenceKey = translation.replace('@:', '');
          const referenceValue = referenceLookup?.[referenceKey];
          if (referenceValue) {
            acc[key] = referenceValue;
          } else {
            acc[key] = key;
            console.log(`No translation for ${referenceKey}`);
          }
        } else {
          acc[key] = translation;
        }
      }
      return acc;
    }, {});
  } catch (error) {
    console.log('Translation references failed', error);
    return translations;
  }
}
/**
 * Recursively creates a lookup object from the given translations object.
 *
 * @param {any} translations - The translations object to create a lookup from. This can be a nested object structure.
 * @param {IDictionary<string>} result - The result object that will be populated with the lookup data.
 * @param {string} [keyPrefix] - An optional prefix that will be prepended to the keys in the lookup object.
 * @returns {IDictionary<string>} The populated lookup object.
 */
function rdlCreateTranslationReferenceLookup(translations, result = {}, keyPrefix) {
  return Object.keys(translations).reduce((acc, key) => {
    if (typeof translations[key] === 'object') {
      const runningKeyPrefix = keyPrefix ? `${keyPrefix}.${key}` : key;
      acc = {
        ...acc,
        ...rdlCreateTranslationReferenceLookup(translations[key], result, runningKeyPrefix)
      };
    } else {
      const translation = translations[key];
      const referenceKey = keyPrefix ? `${keyPrefix}.${key}` : key;
      acc[referenceKey] = translation;
    }
    return acc;
  }, result);
}

/**
 * Generated bundle index. Do not edit.
 */

export { rdlCreateTranslationReferenceLookup, rdlMapReferencedTranslation };
